import sha512 from 'crypto-js/sha512';
import Base64 from 'crypto-js/enc-base64';

export function hashSha512(str) {
  return Base64.stringify(sha512(str));
}
